export default {
  ['title']: '登录',
  ['submit-text']: '登录',
  ['reset-text']: '重置密码',
  ['email']: '邮箱',
  ['password']: '密码',
  ['placeholder-input']: '请输入',
  ['message-submit-success']: '登录成功'
}
